import React from 'react';

const PrintingOffsetsRect = ({pageBox, printingOffsets, style }) => {
  const { l, t, r, b } = pageBox;
  const { l: offL, t: offT, r: offR, b: offB } = printingOffsets;
  return (
    <rect
      x={l + offL}
      y={t + offT}
      width={r + offR - offL}
      height={b + offB - offT}
      fill="none"
      stroke="#E80202"
      strokeWidth={style.strokeWidth}
    />
  );
};

export default React.memo(PrintingOffsetsRect);